import { render, staticRenderFns } from "./CardPrestation.vue?vue&type=template&id=ca856ede&scoped=true"
import script from "./CardPrestation.vue?vue&type=script&lang=js"
export * from "./CardPrestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca856ede",
  null
  
)

export default component.exports